// Based on TiMessengerTestTreiber.yaml 2.0.0
/**
 * Membership state of an account for a room
 */
export type RoomMembershipState = 'knock' | 'invite' | 'join' | 'ban' | 'leave';

export const RoomMembershipState = {
  Knock: 'knock' as RoomMembershipState,

  Invite: 'invite' as RoomMembershipState,

  Join: 'join' as RoomMembershipState,

  Ban: 'ban' as RoomMembershipState,

  Leave: 'leave' as RoomMembershipState
};
